module.exports = __webpack_public_path__ + "static/poster@small-350227361e5aca6a6e19f87f2ce27538.jpg";